









































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { getModule } from 'vuex-module-decorators'
import { PaymentsModule } from '@/store/modules/payments.module'
import { EAutoPayItemStatus, IAutoPayItem } from '@zunta/configurations'
import Card from '@/components/Card.vue'

enum SECTION {
  NO_ITEM = 'no-item',
  TODO = 'todo',
  NEEDS_REVIEW = 'needs-review',
  UPCOMING = 'upcoming',
  DECLINED = 'declined'
}

@Component({
  components: {
    Card,
    Icon
  }
})
export default class ReviewSidebar extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  SECTION: any = SECTION
  sectionNames: any = {
    'needs-review': EAutoPayItemStatus.NEEDS_REVIEW,
    'declined': EAutoPayItemStatus.DECLINED,
    'upcoming': EAutoPayItemStatus.UPCOMING,
    'no-item': SECTION.NO_ITEM,
    'todo': SECTION.TODO
  }

  get section () {
    return this.$route.params.section
  }

  get scheduleItems () {
    return this.$store.state.payments.autoPayItems
  }

  get toDoScheduleItems () {
    return this.scheduleItems.filter((item: IAutoPayItem) => {
      return item.status !== EAutoPayItemStatus.UPCOMING
    })
  }

  get upcomingScheduleItems () {
    return this.scheduleItems.filter((item: IAutoPayItem) => {
      return item.status === EAutoPayItemStatus.UPCOMING
    })
  }

  get needsReviewScheduleItems () {
    return this.scheduleItems.filter((item: IAutoPayItem) => {
      return item.status === EAutoPayItemStatus.NEEDS_REVIEW
    })
  }

  get declinedScheduleItems () {
    return this.scheduleItems.filter((item: IAutoPayItem) => {
      return item.status === EAutoPayItemStatus.DECLINED
    })
  }

  getSectionScheduleData (section: string) {
    if (!this.sectionNames[section]) {
      return []
    }

    if (this.sectionNames[section] === SECTION.TODO) {
      return this.scheduleItems.filter((item: IAutoPayItem) => {
        return item.status !== EAutoPayItemStatus.UPCOMING
      })
    }

    return this.scheduleItems.filter((item: IAutoPayItem) => {
      return item.status === this.sectionNames[section]
    })
  }

  goToSection (section: string) {
    const scheduleItem = this.getSectionScheduleData(section)[0]
    this.$router.push({
      name: 'management-payments-review',
      params: {
        section,
        scheduleItemId: scheduleItem ? scheduleItem.id.toString() : SECTION.NO_ITEM
      }
    })
  }
}
